import CryptoJS from 'crypto-js';
import axios from 'axios';
import { btoa, atob } from '../../lib/helpers';
import { dataApproverLimitPerHit } from '../params';
import { postApi } from '../../lib/fetcher';

const list = {
  namespaced: true,

  state() {
    return {
      provinsi: [],
      kabupaten: [],
      kecamatan: [],
      kelurahan: [],
      kodepos: [],
      kodeposOwner: [],
      jenisUsaha: [],
      areaCode: [],
      wilayahApproval: [],
      approvalId1: [],
      approvalId2: [],
      loading: false,
      requestDaerah: null,
      requestApprovalID1: null,
      requestApprovalID2: null,
    };
  },

  mutations: {
    setProvinsi(state, provinsi) {
      state.provinsi = provinsi;
    },
    setKabupaten(state, kabupaten) {
      state.kabupaten = kabupaten;
    },
    setKecamatan(state, kecamatan) {
      state.kecamatan = kecamatan;
    },
    setKelurahan(state, kelurahan) {
      state.kelurahan = kelurahan;
    },
    setKodepos(state, kodepos) {
      state.kodepos = kodepos;
    },
    setKodeposOwner(state, kodepos) {
      state.kodeposOwner = kodepos;
    },
    setJenisusaha(state, jenisUsaha) {
      state.jenisUsaha = jenisUsaha;
    },
    setAreaCode(state, areaCode) {
      state.areaCode = areaCode;
    },
    setWilayahApproval(state, wilayahApproval) {
      state.wilayahApproval = wilayahApproval;
    },
    setApprovalId1(state, approvalId) {
      state.approvalId1 = approvalId;
    },
    setApprovalId2(state, approvalId) {
      state.approvalId2 = approvalId;
    },
    clearApproval(state) {
      state.approvalId1 = [];
      state.approvalId2 = [];
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setCancelationDaerah(state, payload) {
      state.requestDaerah = payload;
    },
    setRequestApprovalID1(state, payload) {
      state.requestApprovalID1 = payload;
    },
    setRequestApprovalID2(state, payload) {
      state.requestApprovalID2 = payload;
    },
  },

  actions: {
    async fetchDaerah(ctx, { date, id, category }) {
      ctx.commit('setLoading', true);
      let capitalized = category.charAt(0).toUpperCase() + category.slice(1);
      capitalized = capitalized.replace('-', '');
      let data;
      switch (category) {
        case 'kabupaten':
          data = JSON.stringify({
            id_prov: id,
            version: btoa(
              CryptoJS.SHA256(
                id + date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kecamatan':
          data = JSON.stringify({
            id_kab: id,
            version: btoa(
              CryptoJS.SHA256(
                id + date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kelurahan':
          data = JSON.stringify({
            id_kec: id,
            version: btoa(
              CryptoJS.SHA256(
                id + date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        case 'kode-pos':
          data = JSON.stringify({
            kelurahan: id,
            version: btoa(
              CryptoJS.SHA256(
                id + date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
        default:
          data = JSON.stringify({
            version: btoa(
              CryptoJS.SHA256(
                date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
          });
          break;
      }
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/master/${category}/list`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      await axios(config)
        .then((response) => {
          if (response.data.code == '200') {
            ctx.commit(`set${capitalized}`, response.data.data.list);
          }
        })
        .catch((error) => {
          if (error.response.status == '403') {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: error.response.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          } else if (error.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
        });

      ctx.commit('setLoading', false);
    },

    async getDaerah(ctx, { query }) {
      if (ctx.state.requestDaerah) ctx.state.requestDaerah.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelationDaerah', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        q: query,
      });

      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/master/kode-pos/postal-code-list`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
        cancelToken: axiosSource.token,
      };

      await axios(config)
        .then((response) => {
          if (response.data.code != '200') {
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }
          } else {
            ctx.commit('setKodepos', response.data.data);
          }
        })
        .catch(() => {})
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },

    async getDaerahCustom(ctx, { query, typeData = false }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        q: query,
      });

      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/master/kode-pos/postal-code-list`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };

      await axios(config)
        .then((response) => {
          if (response.data.code != '200') {
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }
          } else if (typeData == 'owner') {
            ctx.commit('setKodeposOwner', response.data.data);
          } else {
            ctx.commit('setKodepos', response.data.data);
          }
        })
        .catch(() => {})
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },

    async getJenisUsaha(ctx, { date, searchName }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        page: '1',
        limit: '10000',
        sort_by: 'mcc_name ASC',
        search: { mcc_name: searchName },
        version: btoa(
          CryptoJS.SHA256(
            `${'110000'}${date}${atob(
              process.env.VUE_APP_STRING_EXTRA1.slice(0, -3)
            )}`
          ).toString()
        ),
      });
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/setting-fee/jenis-usaha/list`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };

      const doGetOut = () => ctx.dispatch('logout', null, { root: true });

      await axios(config)
        .then((response) => {
          if (response.data.code != 200) {
            if (response.data.code == '401') doGetOut();
          } else {
            ctx.commit('setJenisusaha', response.data.data.list);
          }
        })
        .catch((err) => {
          if (err.response.status == '403') {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: err.response.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          } else if (err.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
          // ctx.dispatch('logout', null, { root: true })
        });

      ctx.commit('setLoading', false);
    },

    async getAreaCode(ctx, { date, query }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        q: query,
        version: btoa(
          CryptoJS.SHA256(
            query + date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/master/kode-area/index`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };

      const doGetOut = () => ctx.dispatch('logout', null, { root: true });

      await axios(config)
        .then((response) => {
          if (response.data.code != 200) {
            if (response.data.code == '401') doGetOut();
          } else {
            ctx.commit('setAreaCode', response.data.data.list);
          }
        })
        .catch((err) => {
          if (err.response.status == '403') {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: err.response.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          } else if (err.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
          // ctx.dispatch('logout', null, { root: true })
        });

      ctx.commit('setLoading', false);
    },

    async getWilayahApproval(ctx, { date }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        page: '1',
        limit: '10000',
        sort_by: 'id ASC',
        version: btoa(
          CryptoJS.SHA256(
            `${'110000'}${date}${atob(
              process.env.VUE_APP_STRING_EXTRA1.slice(0, -3)
            )}`
          ).toString()
        ),
      });
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/wilayah-approval/wilayah-approval/list`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };

      const doGetOut = () => ctx.dispatch('logout', null, { root: true });

      await axios(config)
        .then((response) => {
          if (response.data.code != 200) {
            if (response.data.code == '401') doGetOut();
          } else {
            ctx.commit('setWilayahApproval', response.data.data.list);
          }
        })
        .catch((err) => {
          if (err.response.status == '403') {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: err.response.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          } else if (err.response.status == '401') {
            ctx.dispatch('logout', null, { root: true });
          }
          // ctx.dispatch('logout', null, { root: true })
        });

      ctx.commit('setLoading', false);
    },

    async getApprovalId1(ctx, { date, role, search, kodepos }) {
      if (ctx.state.requestApprovalID1) ctx.state.requestApprovalID1.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setRequestApprovalID1', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        page: '1',
        limit: dataApproverLimitPerHit,
        sort_by: 'id ASC',
        role,
        search,
        kodepos,
        version: btoa(
          CryptoJS.SHA256(
            `${role}1${dataApproverLimitPerHit}${date}${atob(
              process.env.VUE_APP_STRING_EXTRA1.slice(0, -3)
            )}`
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/wilayah-approval/approval-id/users-role`;

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setApprovalId1', responseData.data.list);
      }
    },

    async getApprovalId2(ctx, { date, role, search, kodepos }) {
      if (ctx.state.requestApprovalID2) ctx.state.requestApprovalID2.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setRequestApprovalID2', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        page: '1',
        limit: dataApproverLimitPerHit,
        sort_by: 'id ASC',
        role,
        search,
        kodepos,
        version: btoa(
          CryptoJS.SHA256(
            `${role}1${dataApproverLimitPerHit}${date}${atob(
              process.env.VUE_APP_STRING_EXTRA1.slice(0, -3)
            )}`
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/wilayah-approval/approval-id/users-role`;

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setApprovalId2', responseData.data.list);
      }
    },
  },
};
export default list;
